export interface MarketingParams {
  [key: string]: string;
}

const CLICK_IDS = [
  'gclid',
  'fbclid',
  'msclkid',
  'ttclid',
  'li_fat_id',
  'twclid',
  'sccid',
  'gbraid',
  'wbraid',
];

export function extractMarketingParams(
  urlOrQueryString: string,
): MarketingParams {
  const marketingParams: MarketingParams = {};

  try {
    let searchParams: URLSearchParams;

    if (urlOrQueryString.startsWith('http')) {
      const url = new URL(urlOrQueryString);
      searchParams = url.searchParams;
    } else if (urlOrQueryString.startsWith('?')) {
      searchParams = new URLSearchParams(urlOrQueryString);
    } else {
      searchParams = new URLSearchParams('?' + urlOrQueryString);
    }

    for (const [key, value] of searchParams.entries()) {
      const lowercaseKey = key.toLowerCase();
      if (lowercaseKey.startsWith('utm_') || CLICK_IDS.includes(lowercaseKey)) {
        marketingParams[key] = value;
      }
    }
  } catch {
    // Silently ignore parsing errors
  }

  return marketingParams;
}
